export type AzureMapResults = {
  geometry: {
    coordinates: [number, number]; // [lon, lat]
  };
  properties: {
    geocodePoints?: {
      calculationMethod?: string;
    }[];
    address?: {
      formattedAddress?: string;
      streetNumber?: string;
      streetName?: string;
      locality?: string;
      postalCode?: string;
      adminDistricts?: {
        shortName?: string;
      }[];
    };
  };
};

export type GeocodeResponse = {
  geocodeData: {
    results: AzureMapResults[];
  };
};
